import { Options } from 'highcharts';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { formatters } from '@utils/formattersV2';

export const salesChartOptions = ({
  existingBuyerSales,
  newBuyerSales,
}: {
  existingBuyerSales: number;
  newBuyerSales: number;
}): Options => ({
  chart: {
    type: 'column',
    height: 400,
    backgroundColor: 'transparent',
    spacingTop: 10,
    spacingBottom: 10,
  },
  title: {
    text: 'Total Sales for New Buyer vs. Existing buyer',
    style: {
      fontSize: '16px',
      fontWeight: '600',
      color: unifiedPlatformColorPalette.black,
    },
  },
  xAxis: {
    categories: ['Existing Buyers', 'New Buyers'],
    labels: { style: { fontSize: '13px' } },
    lineColor: unifiedPlatformColorPalette.lightGrey300,
  },
  yAxis: {
    min: 0,
    title: { text: '' },
    labels: {
      formatter() {
        return formatters.currency(this.value as number, {
          decimals: 0,
        });
      },
      style: { fontSize: '12px' },
    },
    gridLineColor: unifiedPlatformColorPalette.lightGrey300,
  },
  legend: { enabled: false },
  tooltip: { enabled: false },
  plotOptions: {
    column: {
      pointWidth: 40,
      borderRadius: 5,
      groupPadding: 0,
      pointPadding: 0,
      dataLabels: {
        enabled: true,
        formatter() {
          return formatters.currency(this.y, {
            full: true,
            decimals: 0,
          });
        },
        style: {
          fontSize: '13px',
          fontWeight: 'bold',
          color: unifiedPlatformColorPalette.black,
          textOutline: 'none',
        },
      },
    },
  },
  series: [
    {
      name: 'Total Sales',
      type: 'column',
      data: [
        {
          y: existingBuyerSales,
          color: unifiedPlatformColorPalette.chartLightGreen,
        },
        {
          y: newBuyerSales,
          color: unifiedPlatformColorPalette.chartDarkGreen,
        },
      ],
      colorByPoint: false,
    },
  ],
  credits: { enabled: false },
  exporting: { enabled: false },
});
